export const palette = {
  primary: {
    main: "#414042"
  },
  secondary: {
    main: "#dc0032"
  }
};
